'use strict';

var processInclude = require('base/util');

document.addEventListener('DOMContentLoaded', () => {
    processInclude(require('./components/checkBalance'));
});
